module.exports = __webpack_public_path__ + "img/wang.1d661c7f.jpg";